let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("126lu")).then(() => parcelRequire('33iwa'));